import { AuthChannelType } from '@hotelplan/fdr.lib.ident.auth-config';
import { useAuthentication } from '@hotelplan/fdr.lib.ident.with-auth';
import { FdrImage } from '@hotelplan/supergraph-api';
import { TBookmarkItem } from 'components/domain/fdr-bookmark/fdr-bookmark-types';
import {
  isFdrGeoBookmark,
  isFdrProductBookmark,
  isFdrThemeBookmark,
} from 'components/domain/fdr-bookmark/fdr-bookmark.utils';
import {
  isFdrAdventureTravelProduct,
  isFdrHotelProduct,
  isFdrRoundTripProduct,
} from 'components/domain/fdr-product/fdr-product.utils';

function useBookmarkImage(object: TBookmarkItem): FdrImage {
  const { channelType } = useAuthentication();
  const isB2B = channelType === AuthChannelType.B2B;

  if (
    isFdrProductBookmark(object) &&
    isFdrAdventureTravelProduct(object.product)
  ) {
    if (isB2B && object.product.googleStaticMapImage) {
      return object.product.googleStaticMapImage;
    }

    return object.product.headerImages?.[0];
  }

  if (isFdrProductBookmark(object) && isFdrRoundTripProduct(object.product)) {
    if (isB2B && object.product.mapImages?.length) {
      return object.product.mapImages?.[0];
    }

    return object.product.hero;
  }

  if (isFdrProductBookmark(object) && isFdrHotelProduct(object.product)) {
    return object.product.hero;
  }

  if (isFdrGeoBookmark(object)) {
    return object.geo.hero;
  }

  if (isFdrThemeBookmark(object)) {
    return (object as any).theme.hero;
  }
}

export default useBookmarkImage;
